export default {
  "box-name": "",
  "public-btn-text1": "今すぐ取引",
  "public-btn-text2": "取引商品一覧はこちら",
  screen0: {
    title: "CFD配当金",
    desc: `CFD配当金は、MT4アカウントの残高に"Dividend"と注記され、入金または出金として付与されます。`,
  },
  screen1: {
    title: "最大レバレッジと証拠金率",
  },
  screen2: {
    title: "金融市場に簡単アクセス",
  },
  股息调整: "配当金調整",
  了解您在股票和指数差价合约交易中的股息调整和分配机制:
    "個別株CFDおよび株価指数CFD取引における配当金調整と分配の仕組みについて",
  了解指数差价合约: "株価指数CFDについて",
  了解股票差价合约: "個別株CFDの詳細",
  股息是上市公司从利润或保留资金中定期分配给股东的资金:
    "配当金とは、上場企業またはETFが投資家に定期的に分配する収入です。株式、指数、ETF・CFDの場合、実際の配当金支払い状況に基づき、保有口座に現金配当金が調整されます。",
  除息日与交易优化: "配当落ち日と取引の最適化",
  指数差价合约的除息日由指数提供商根据成分股设定:
    "配当落ち日は、株式、指数、またはETFの発行会社によって設定されます。権利落ち日には、CFDのロングポジションには現金配当を受取り、ショートポジションには手数料がかかります。今後の配当落ち日を確認することで、利回りを効果的に管理・最適化できます。",
  股息调整明细: " 配当金一覧",
  差价合约交易中相关产品的股息数据:
    "CFD取引における原資産の配当金は、買いと売りに分けて表示されます。",
  交易产品: "Trading Products",
  多头股息: "Long Dividends",
  空头股息: "Short Dividends",
  除息日: "Ex-dividend Dates",
  即刻交易: "今すぐ取引をする",
  股息的常见问题: "配当金に関するよくある質問",
  qaList: [
    {
      q: "1. 配当金と配当落ち日とは",
      a: [
        "配当金とは、上場企業またはETFが利益または資産から投資家に分配する資金です。権利落ち日とは、資産が正式に配当金を受け払い、価格を調整する日です。通常、その日の取引開始前に純資産額または相場価格が調整されます。",
        "CFD銘柄（株式、指数、またはETF）では、配当落ち日により価格が調整され、MT4/MT5システムにより、対応する金額がロングポジションに付与されるか、ショートポジションに引かれます。",
      ],
    },
    {
      q: "2. 配当金受払のタイミング",
      a: [
        "株価指数CFDの配当調整は通常、配当落ち日の00:00 ～ 01:00(MT 時間)の間に MT4/MT5取引口座に反映され、「Dividend」としてマークされます。",
        "株式およびETF CFDの配当調整は、通常、配当落ち日の16:30(MT時間)までにMT5取引口座に反映され、「Dividend」としてマークされます。"
      ],
    },
    {
      q: "3. 保有ポジションと配当金の関係",
      a: [
        "ロング（買）ポジションを保有している場合：配当金はMT4/MT5取引口座に入金されます。",
        "ショート（売）ポジションを保有している場合：配当金はMT4/MT5取引口座から出金されます。",
        "注意：ETF銘柄の配当調整も同様のルールに従い、ファンド会社が発表する配当データに基づいて調整されます。"
      ],
    },
    {
      q: "4. 配当金の計算方法",
      a: [
        "ロング（買）ポジションの場合：取引ロット数 x 契約サイズ x 配当（買）額（決済通貨建てでの計算となります）",
        "ショート（売）ポジションの場合：取引ロット数 x 契約サイズ x 配当（売）額（決済通貨建てでの計算となります）",
      ],
    },
    {
      q: "5.配当金の計算例",
      a: [
        "取引銘柄がSPXUSD、配当金受取日が2024年10月11日、配当（買）額が0.050 USD、配当（売）額が-0.050 USDのケースを考えます。",
        "配当受取日前日（10月10日）に1ロットのロングポジションを保有している場合、配当金は以下の計算式によって求められます。",

        "配当金額 = 1（ロット）x 100（契約サイズ）x 0.050（配当（買）額）= 5 USD",

        "5ドルの配当金はMT 時間00:00 ～ 01:00(日本時間午前11時から午後12時)の間にMT4/MT5取引口座に入金され、「Dividend」と注記されます。",

        "同様のケースでショートポジションを保有していた場合、5ドルがMT4/MT5取引口座から出金され、「Dividend」と注記されます。",
      ],
    },
    {
      q: "6.注意事項",
      a: [
        "配当調整は、株価指数CFD、ETF、株式CFDに適用されます。",
        "調整額は、配当データ、ポジションの方向、および配当落ち日の取引量に基づいて自動的に計算・処理されます。",
        "ETF CFDの配当額は、対応するファンドの公式発表によって決定され、原資産の変動により変動する場合があります。",
        "配当調整によってポジションのスプレッドや取引コストは変更されませんが、口座の純資産と残高に影響します。",
        "特定のETFまたは指数の配当落ちの仕組みを知りたい場合は、[配当調整の詳細]をご確認いただくか、アカウントマネージャーにお問い合わせください。"
      ],
    },
  ],
};
